import React, { useState, useEffect } from 'react'
import LogoImage from "../../assets/img/logo.svg";
import router from '../../router'
import Toast from "../../plugins/useToast";
import axios from '../../plugins/axios'
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconCheckBlue} from '../../assets/icons/ic-check-blue.svg'
import {ReactComponent as IconCheckWhite} from '../../assets/icons/ic-check-white.svg'

const ResetPassword = () => {
    const { t } = useTranslation()
    const [isSecure, setIsSecure] = useState(true)
    const [curPass, setCurPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [confirmPass, setConfirmPass] = useState('')
    const [isDisabled, setIsDisabled] = useState(true)

    const handlePassword = async () => {
        try {
            if (isDisabled) return
            const res = await axios.put(`/user/me/password`, { newPassword: newPass, oldPassword: curPass })
            if (res.code != '200') throw res
            router.navigate('/dashboard')
        } catch (err) {
            Toast({ isSuccess: false , msg : err.message || 'Please retry later.' });
        }
    }

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            handlePassword()
        }
    }

    useEffect(() => {
        if (
            /[a-z]/.test(newPass) &&
            /[0-9]/.test(newPass) &&
            /[^a-zA-Z0-9]/.test(newPass) &&
            (newPass.length >= 8 && newPass.length <= 16) &&
            newPass === confirmPass &&
            curPass
        ) {
            setIsDisabled(false)
          } else {
            setIsDisabled(true)
          }
    }, [curPass, newPass, confirmPass])

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[9999]">
            <div
                className="fixed inset-0 bg-[#113577] flex items-center justify-center z-50"
                style={{
                    // backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div
                    className="w-[468px] h-[72px] absolute top-[260px] left-1/2 ml-[-234px]"
                    style={{
                    backgroundImage: `url(${LogoImage})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    }}
                />
                <div className="px-4 py-4 w-[540px] h-[457px] bg-[#0D2756] flex flex-col items-center" style={{ marginTop: 184 }}>
                    <div className="text-[#E1E4E5] mt-4" style={{ fontWeight: 500, fontSize: 24, lineHeight: '120%' }}>Reset password</div>
                    <div className="text-[#B5B8BD] text-center mt-3" style={{ fontSize: 16, lineHeight: '120%' }}>{`For security reasons, you will be required to change your password\nupon first logging in.`}​</div>
                    <div className="w-full h-[60px] bg-white mt-4" style={{ borderRadius: 8, padding: '14px 23px' }}>
                        <input className="w-full h-full font-light" placeholder='Current password' value={curPass} onKeyDown={handleEnter} onChange={(e) => { setCurPass(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 20 }} />
                    </div>
                    <div className="w-full h-[60px] bg-white mt-4" style={{ borderRadius: 8, padding: '14px 23px' }}>
                        <input className="w-full h-full font-light" placeholder='Enter new password' value={newPass} onKeyDown={handleEnter} onChange={(e) => { setNewPass(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 20 }} />
                    </div>
                    <div className="flex w-full mt-2">
                        <div className="flex items-center mr-6" style={{ color: '#ABAEB2' }}>
                            {
                                (/[a-z]/.test(newPass) ? <IconCheckBlue className="mr-1"/> : <IconCheckWhite className="mr-1"/>)
                            }
                            {'One lowercase letter'}
                        </div>
                        <div className="flex items-center" style={{ color: '#ABAEB2' }}>
                            {
                                (/[0-9]/.test(newPass) ? <IconCheckBlue className="mr-1"/> : <IconCheckWhite className="mr-1"/>)
                            }
                            {'One number'}
                        </div>
                    </div>
                    <div className="flex w-full mt-2">
                        <div className="flex items-center mr-6" style={{ color: '#ABAEB2' }}>
                            {
                                (/[^a-zA-Z0-9]/.test(newPass) ? <IconCheckBlue className="mr-1"/> : <IconCheckWhite className="mr-1"/>)
                            }
                            {'One special character'}
                        </div>
                        <div className="flex items-center" style={{ color: '#ABAEB2' }}>
                            {
                                ((newPass.length >= 8 && newPass.length <= 16) ? <IconCheckBlue className="mr-1"/> : <IconCheckWhite className="mr-1"/>)
                            }
                            {'8-16 characters'}
                        </div>
                    </div>
                    <div className="w-full h-[60px] bg-white mt-4" style={{ borderRadius: 8, padding: '14px 23px' }}>
                        <input className="w-full h-full font-light" placeholder='Confirm new password' value={confirmPass} onKeyDown={handleEnter} onChange={(e) => { setConfirmPass(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 20 }} />
                    </div>
                    <button
                        disabled={isDisabled}
                        onClick={handlePassword}
                        className="mt-6 w-[512px] h-[60px] bg-gradient-to-b from-[#3182F7] to-[#1562D1] text-white font-light text-[20px] rounded-[8px]"
                        style={{ opacity: !isDisabled ? 1 : 0.4 }}
                    >
                        { `OK` }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword